<mat-card
    class="altair-card visualization-card mb-25 pb-0 bg-white border-radius border-none d-block"
>
    <mat-card-content>
        <div ngModel #svgTree style="margin: 0 auto;"></div>
    </mat-card-content>
</mat-card>
